import { render, staticRenderFns } from "./ProductSelectionModal.vue?vue&type=template&id=3b567746&scoped=true&"
import script from "./ProductSelectionModal.vue?vue&type=script&lang=js&"
export * from "./ProductSelectionModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductSelectionModal.vue?vue&type=style&index=0&id=3b567746&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b567746",
  null
  
)

export default component.exports